<div class='printme' [innerHTML]="LegalTypeContent">
</div>
<app-loader></app-loader>
<div class="app-page__wrapper printmenot">
  <app-header-page></app-header-page>
  <div class="page-content__container">

    @if (LegalTypeContent) {
      <div>
        <button mat-button color="primary" printSectionId="print-section" (click)="printType()">
          <mat-icon inline=true>print</mat-icon> Print
        </button>
        <div id="print-section" [innerHTML]="LegalTypeContent" class="html-content">
        </div>
        <form [formGroup]="legalInfoForm" (submit)="Save()">
          @if (claims && userType === 'external' && (!isPrivacyPolicyRead || !isTermsOfUseRead)) {
            <div class="action-panal">
              <mat-checkbox formControlName="acceptPolicy">I accept the {{legalInfoType}}</mat-checkbox>
              <button [disabled]="!enableSave" class="float-right" mat-flat-button color="primary">
                <mat-icon inline=true>save</mat-icon>Save
              </button>
            </div>
          }
        </form>
      </div>
    }
    @if (isError) {
      <mat-error>{{errorMessage}}</mat-error>
    }
  </div>
  @if (!claims && LegalTypeContent) {
    <div>
      <app-footer></app-footer>
    </div>
  }
</div>
